/**
 * Use this to define a block of html on the current binding context.
 *
 * Useful for exposing blocks of html to the cms.
 *
 * Usage:
 *
 *      {{#define: 'markup'}}<div>hello world</div>{{/define}}
 *
 *      <div data-bind="html: markup"></div>
 */
define('ko/customBinding/define',['knockout'], function(ko) {

    ko.bindingHandlers.define = {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {

            var wrapper = document.createElement('div');
            ko.virtualElements.setDomNodeChildren(wrapper, ko.virtualElements.childNodes(element));
            bindingContext[valueAccessor()] = wrapper.innerHTML;

            return { 'controlsDescendantBindings': true };
        }
    };

    ko.virtualElements.allowedBindings.define = true;

});

